(function () {
  'use strict';

  if (window.AxiomSearchPlaceholder) return;
  window.AxiomSearchPlaceholder = true;

  /*
   * Rolling search placeholder. Fields marked data-rolling-placeholder (snippet
   * search-rolling-placeholder) keep their first suggestion as the real placeholder, for
   * assistive tech and without JavaScript. Here a copy laid over the empty field rolls through
   * the suggestions every 2.5s. It stops while the field has focus or text, when it is off screen
   * or hidden, and with reduced motion. The field is measured on start and on resize only.
   */
  var INTERVAL = 2500;

  function reducedMotion() {
    return window.Axiom && typeof window.Axiom.prefersReducedMotion === 'function'
      ? window.Axiom.prefersReducedMotion()
      : window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function RollingPlaceholder(input, words) {
    this.input = input;
    this.words = words;
    this.index = 0;
    this.visible = false;
    this.timer = null;

    var roll = document.createElement('span');
    roll.className = 'search-roll';
    roll.setAttribute('aria-hidden', 'true');
    this.spans = words.map(function (word, index) {
      var span = document.createElement('span');
      span.className = 'search-roll__word' + (index === 0 ? ' is-active' : '');
      span.textContent = word;
      roll.appendChild(span);
      return span;
    });
    this.roll = roll;
    input.insertAdjacentElement('afterend', roll);
    input.classList.add('search-roll-field');

    this.measure();
    this.sync();

    input.addEventListener('focus', this.sync.bind(this));
    input.addEventListener('blur', this.sync.bind(this));
    input.addEventListener('input', this.sync.bind(this));
    // A form reset or a script that clears the field.
    input.form && input.form.addEventListener('reset', () => setTimeout(this.sync.bind(this)));
    document.addEventListener('visibilitychange', this.sync.bind(this));

    if ('ResizeObserver' in window) {
      new ResizeObserver(() => this.measure()).observe(input);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        this.visible = entries[entries.length - 1].isIntersecting;
        this.sync();
      }).observe(input);
    } else {
      this.visible = true;
    }
  }

  // Lays the copy over the field's text box, in the field's own type and placeholder colour.
  RollingPlaceholder.prototype.measure = function () {
    var input = this.input;
    var style = getComputedStyle(input);
    // The placeholder's own colour, read while it isn't hidden by .search-roll-field.
    var hiding = input.classList.contains('search-roll-field');
    if (hiding) input.classList.remove('search-roll-field');
    var placeholderColor = getComputedStyle(input, '::placeholder').color;
    if (hiding) input.classList.add('search-roll-field');
    var roll = this.roll;
    var padStart = parseFloat(style.paddingLeft) + parseFloat(style.borderLeftWidth);
    var padEnd = parseFloat(style.paddingRight) + parseFloat(style.borderRightWidth);
    roll.style.left = input.offsetLeft + padStart + 'px';
    roll.style.top = input.offsetTop + 'px';
    roll.style.width = Math.max(0, input.offsetWidth - padStart - padEnd) + 'px';
    roll.style.height = input.offsetHeight + 'px';
    roll.style.fontFamily = style.fontFamily;
    roll.style.fontSize = style.fontSize;
    roll.style.fontWeight = style.fontWeight;
    roll.style.fontStyle = style.fontStyle;
    roll.style.letterSpacing = style.letterSpacing;
    roll.style.textTransform = style.textTransform;
    roll.style.textAlign = style.textAlign;
    roll.style.direction = style.direction;
    roll.style.lineHeight = 'normal';
    var usable = placeholderColor && placeholderColor !== style.color && !/^rgba\(.*,\s*0\)$|transparent/.test(placeholderColor);
    roll.style.color = usable ? placeholderColor : style.color;
    roll.style.opacity = usable ? '' : '0.6';
  };

  RollingPlaceholder.prototype.sync = function () {
    var empty = !this.input.value;
    var focused = document.activeElement === this.input;
    this.roll.hidden = !empty;
    this.input.classList.toggle('search-roll-field', empty);
    var run = empty && !focused && this.visible && !document.hidden;
    if (run && !this.timer) {
      this.timer = setInterval(this.next.bind(this), INTERVAL);
    } else if (!run && this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  RollingPlaceholder.prototype.next = function () {
    if (!this.input.isConnected) {
      clearInterval(this.timer);
      return;
    }
    var current = this.spans[this.index];
    this.index = (this.index + 1) % this.spans.length;
    var incoming = this.spans[this.index];
    // The incoming word waits below the field, without a transition.
    incoming.classList.add('is-parked');
    incoming.classList.remove('is-leaving');
    void incoming.offsetWidth;
    incoming.classList.remove('is-parked');
    current.classList.remove('is-active');
    current.classList.add('is-leaving');
    incoming.classList.add('is-active');
  };

  function init(scope) {
    if (reducedMotion()) return;
    (scope || document).querySelectorAll('input[data-rolling-placeholder]').forEach(function (input) {
      if (input.hasAttribute('data-rolling-ready')) return;
      input.setAttribute('data-rolling-ready', '');
      var words;
      try {
        words = JSON.parse(input.getAttribute('data-rolling-placeholder'));
      } catch (error) {
        return;
      }
      if (Array.isArray(words) && words.length > 1) new RollingPlaceholder(input, words);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
